// @generated by protoc-gen-es v2.10.2 with parameter "target=js+dts,import_extension=none"
// @generated from file receipt/v1/receipt.proto (package receipt.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, serviceDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file receipt/v1/receipt.proto.
 */
export const file_receipt_v1_receipt = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message receipt.v1.UploadReceiptRequest.
 * Use `create(UploadReceiptRequestSchema)` to create a new message.
 */
export const UploadReceiptRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 0);

/**
 * Describes the message receipt.v1.UploadReceiptResponse.
 * Use `create(UploadReceiptResponseSchema)` to create a new message.
 */
export const UploadReceiptResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 1);

/**
 * Describes the message receipt.v1.ReceiptItem.
 * Use `create(ReceiptItemSchema)` to create a new message.
 */
export const ReceiptItemSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 2);

/**
 * Describes the message receipt.v1.SaleItem.
 * Use `create(SaleItemSchema)` to create a new message.
 */
export const SaleItemSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 3);

/**
 * Describes the message receipt.v1.CreateReceiptRequest.
 * Use `create(CreateReceiptRequestSchema)` to create a new message.
 */
export const CreateReceiptRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 4);

/**
 * Describes the message receipt.v1.CreateReceiptResponse.
 * Use `create(CreateReceiptResponseSchema)` to create a new message.
 */
export const CreateReceiptResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 5);

/**
 * Describes the message receipt.v1.SaveReceiptRequest.
 * Use `create(SaveReceiptRequestSchema)` to create a new message.
 */
export const SaveReceiptRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 6);

/**
 * Describes the message receipt.v1.SaveReceiptResponse.
 * Use `create(SaveReceiptResponseSchema)` to create a new message.
 */
export const SaveReceiptResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 7);

/**
 * Describes the message receipt.v1.ListReceiptsRequest.
 * Use `create(ListReceiptsRequestSchema)` to create a new message.
 */
export const ListReceiptsRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 8);

/**
 * Describes the message receipt.v1.ListReceiptsResponse.
 * Use `create(ListReceiptsResponseSchema)` to create a new message.
 */
export const ListReceiptsResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 9);

/**
 * Describes the message receipt.v1.ReceiptSummary.
 * Use `create(ReceiptSummarySchema)` to create a new message.
 */
export const ReceiptSummarySchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 10);

/**
 * Describes the message receipt.v1.GetReceiptRequest.
 * Use `create(GetReceiptRequestSchema)` to create a new message.
 */
export const GetReceiptRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 11);

/**
 * Describes the message receipt.v1.GetReceiptResponse.
 * Use `create(GetReceiptResponseSchema)` to create a new message.
 */
export const GetReceiptResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 12);

/**
 * Describes the message receipt.v1.DeleteReceiptRequest.
 * Use `create(DeleteReceiptRequestSchema)` to create a new message.
 */
export const DeleteReceiptRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 13);

/**
 * Describes the message receipt.v1.DeleteReceiptResponse.
 * Use `create(DeleteReceiptResponseSchema)` to create a new message.
 */
export const DeleteReceiptResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 14);

/**
 * Describes the message receipt.v1.SetItemDescriptionMappingRequest.
 * Use `create(SetItemDescriptionMappingRequestSchema)` to create a new message.
 */
export const SetItemDescriptionMappingRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 15);

/**
 * Describes the message receipt.v1.SetItemDescriptionMappingResponse.
 * Use `create(SetItemDescriptionMappingResponseSchema)` to create a new message.
 */
export const SetItemDescriptionMappingResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 16);

/**
 * Describes the message receipt.v1.GetItemDescriptionMappingsRequest.
 * Use `create(GetItemDescriptionMappingsRequestSchema)` to create a new message.
 */
export const GetItemDescriptionMappingsRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 17);

/**
 * Describes the message receipt.v1.GetItemDescriptionMappingsResponse.
 * Use `create(GetItemDescriptionMappingsResponseSchema)` to create a new message.
 */
export const GetItemDescriptionMappingsResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 18);

/**
 * Describes the message receipt.v1.ListItemDescriptionMappingsRequest.
 * Use `create(ListItemDescriptionMappingsRequestSchema)` to create a new message.
 */
export const ListItemDescriptionMappingsRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 19);

/**
 * Describes the message receipt.v1.ListItemDescriptionMappingsResponse.
 * Use `create(ListItemDescriptionMappingsResponseSchema)` to create a new message.
 */
export const ListItemDescriptionMappingsResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 20);

/**
 * Describes the message receipt.v1.DeleteItemDescriptionMappingRequest.
 * Use `create(DeleteItemDescriptionMappingRequestSchema)` to create a new message.
 */
export const DeleteItemDescriptionMappingRequestSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 21);

/**
 * Describes the message receipt.v1.DeleteItemDescriptionMappingResponse.
 * Use `create(DeleteItemDescriptionMappingResponseSchema)` to create a new message.
 */
export const DeleteItemDescriptionMappingResponseSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 22);

/**
 * Describes the message receipt.v1.ItemDescriptionMapping.
 * Use `create(ItemDescriptionMappingSchema)` to create a new message.
 */
export const ItemDescriptionMappingSchema = /*@__PURE__*/
  messageDesc(file_receipt_v1_receipt, 23);

/**
 * Describes the enum receipt.v1.SortField.
 */
export const SortFieldSchema = /*@__PURE__*/
  enumDesc(file_receipt_v1_receipt, 0);

/**
 * SortField specifies which field to sort by.
 *
 * @generated from enum receipt.v1.SortField
 */
export const SortField = /*@__PURE__*/
  tsEnum(SortFieldSchema);

/**
 * Describes the enum receipt.v1.SortOrder.
 */
export const SortOrderSchema = /*@__PURE__*/
  enumDesc(file_receipt_v1_receipt, 1);

/**
 * SortOrder specifies the sort direction.
 *
 * @generated from enum receipt.v1.SortOrder
 */
export const SortOrder = /*@__PURE__*/
  tsEnum(SortOrderSchema);

/**
 * Describes the enum receipt.v1.ProcessingStatus.
 */
export const ProcessingStatusSchema = /*@__PURE__*/
  enumDesc(file_receipt_v1_receipt, 2);

/**
 * ProcessingStatus indicates the current state of async receipt OCR processing.
 *
 * @generated from enum receipt.v1.ProcessingStatus
 */
export const ProcessingStatus = /*@__PURE__*/
  tsEnum(ProcessingStatusSchema);

/**
 * ReceiptUploadService handles receipt image uploads and processing.
 *
 * @generated from service receipt.v1.ReceiptUploadService
 */
export const ReceiptUploadService = /*@__PURE__*/
  serviceDesc(file_receipt_v1_receipt, 0);

